import { type Benefit } from '@/types/benefits/benefitColumnDef';

/** True when deleting the benefit removes it from circuits or from hotels. */
export const isBenefitUsedElsewhere = (benefit: Pick<Benefit, '_count'>) =>
  benefit._count.circuitDaysAsStandard > 0 ||
  benefit._count.circuitDaysAsOptional > 0 ||
  benefit._count.circuitDayStepAccommodations > 0 ||
  benefit._count.hotelAssociatedBenefits > 0;
